

import Vue from 'vue'
import App from './App'
import axios from 'axios'
import store from './store/store.js'
import router from './router'
import './jslib/controlSize'
import './filter/all.js'

import allServer from './server/allServer.js'
import utils from './jslib/utils.js'




require('./assets/style/reset.css')
require('./assets/style/animate.css')
require('./jslib/jquery.min.js')
require('./jslib/router-intercept')
require('./assets/font/iconfont.css')   


Vue.prototype.$utils = utils;
Vue.config.productionTip = false
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin,{width:'3rem'})

import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

Vue.use(Vant);


import XButton from 'vux/src/components/x-button/index.vue'

Vue.component('x-button', XButton)












import VConsole from 'vconsole'


/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js